export default __webpack_public_path__ + "static/media/logo.099b196e.png";